(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDialogController', InfectionPrimaryAccessDialogController);

    InfectionPrimaryAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfectionPrimaryAccess', 'Infection', 'Corporation'];

    function InfectionPrimaryAccessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfectionPrimaryAccess, Infection, Corporation) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infectionPrimaryAccess.id !== null) {
                InfectionPrimaryAccess.update(vm.infectionPrimaryAccess, onSaveSuccess, onSaveError);
            } else {
                InfectionPrimaryAccess.save(vm.infectionPrimaryAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:infectionPrimaryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
